module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-wrapper",
    class: _vm.customClass,
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup-overlay",
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "popup-container",
    style: ({
      minHeight: _vm.height
    })
  }, [_c('header', {
    staticClass: "popup-header",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": require("../assets/icons/icon-close.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab469f6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicPopup.vue
// module id = 651
// module chunks = 1